<main class="login-page" dir="rtl">
  <div class="login-shell">
    <div class="login-card">
      <div class="login-header">
        <div>
          <span class="login-brand">راهداری GPS</span>
          <h1>بررسی اطلاعات خودرو</h1>
        </div>
        <a class="close-button" routerLink="/home" aria-label="بازگشت به صفحه اصلی">
          <mat-icon aria-hidden="true">close</mat-icon>
        </a>
      </div>
      <div class="login-body">
        <p class="form-intro">شماره موبایل را برای بررسی وارد کنید.</p>
        <label for="verification-mobile">شماره موبایل</label>
        <div class="form-group has-icon" [class.direction-ltr]="strMobile">
          <span class="form-control-icon"><mat-icon aria-hidden="true">phone_iphone</mat-icon></span>
          <input id="verification-mobile" type="tel" class="form-control" [disabled]="isSubmitDisabled"
            #strMobileField="ngModel" [(ngModel)]="strMobile" required appPhoneNumberValidation
            [maxLength]="11" [minlength]="11" placeholder="شماره موبایل" inputmode="numeric"
            autocomplete="tel" appNumericOnly (keydown.enter)="submit(strMobileField)" />
        </div>
      </div>
      <div class="login-footer">
        <button type="button" class="submit-button"
          [disabled]="strMobileField.invalid || strMobileField.pristine || isSubmitDisabled"
          (click)="submit(strMobileField)">بررسی</button>
      </div>
    </div>
  </div>
</main>

<ng-template #listDialogTemplate let-modal>
  <div class="modal-header details-header" dir="rtl">
    <div>
      <h2 class="modal-title">خودروهای ثبت‌شده</h2>
      <p>شماره موبایل: <span dir="ltr">{{ strMobile }}</span></p>
    </div>
    <button type="button" class="details-close" aria-label="بستن" (click)="modal.close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body details-body" dir="rtl">
    <button type="button" class="register-button" (click)="registerNew()">+ ثبت خودروی جدید</button>
    <div class="vehicle-list">
      <table>
        <thead><tr><th scope="col">عملیات</th><th scope="col">شماره</th><th scope="col">نام و نام خانوادگی</th><th scope="col">VIN</th><th scope="col">وضعیت</th></tr></thead>
        <tbody>
          <tr *ngFor="let vehicle of vehicles">
            <td><button type="button" class="view-button" (click)="openDetailsDialog(vehicle)">ویرایش</button></td>
            <td>{{ vehicle.iPreregistration ?? '—' }}</td>
            <td>{{ vehicle.strName }} {{ vehicle.strFamily }}</td>
            <td dir="ltr">{{ vehicle.strVIN || '—' }}</td>
            <td>{{ vehicle.strInstallationStatus || '—' }}</td>
          </tr>
          <tr *ngIf="!vehicles.length"><td colspan="5">موردی یافت نشد.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #detailsDialogTemplate let-modal>
  <div class="modal-body p-0 edit-modal-body">
    <app-specialist-registration [editId]="tankerProfile.iPreregistration" [embedded]="true" (savedEdit)="loadVehicles(false, false)" (closeEdit)="modal.close()"></app-specialist-registration>
  </div>
</ng-template>
